import React, { useCallback, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Select } from "../../../../components";
import Button from "../../../../components/common/Button";
import { getServiceAreaOptions } from "../../../../api/service-area";
import { updateDriverServiceArea } from "../../../../api/driver";

const DriverServiceArea = ({ driverId, currentServiceArea, onUpdated }) => {
    const { t } = useTranslation();
    const form = useForm({
        defaultValues: {
            serviceArea: currentServiceArea ?? "",
        },
    });
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const loadOptions = useCallback(async () => {
        const response = await getServiceAreaOptions();
        setOptions(response);
    }, []);

    useEffect(() => {
        loadOptions();
    }, [loadOptions]);

    const normalizeArea = useCallback((value = "") => {
        return value.toString().trim().toLowerCase().replaceAll("_", " ");
    }, []);

    useEffect(() => {
        if (!currentServiceArea) {
            form.reset({ serviceArea: "" });
            return;
        }

        const matchedOption = options.find((option) => {
            return normalizeArea(option?.value) === normalizeArea(currentServiceArea)
                || normalizeArea(option?.label) === normalizeArea(currentServiceArea);
        });

        form.reset({ serviceArea: matchedOption?.value ?? currentServiceArea });
    }, [form, currentServiceArea, options, normalizeArea]);

    const onSubmit = async ({ serviceArea }) => {
        setLoading(true);
        const response = await updateDriverServiceArea(driverId, serviceArea);
        if (response.success && onUpdated) {
            onUpdated();
        }
        setLoading(false);
    };

    return (
        <FormProvider {...form}>
            <Form className="mt-4" onSubmit={form.handleSubmit(onSubmit)}>
                <Select
                    label={t("SERVICE_AREA")}
                    name="serviceArea"
                    options={options}
                    rules={{ required: t("SERVICE_AREA_IS_REQUIRED") }}
                />
                <Button type="submit" variant="primary" loading={loading}>
                    {t("UPDATE")}
                </Button>
            </Form>
        </FormProvider>
    );
};

export default DriverServiceArea;
